/** Whether the run page must eagerly load EVERY finding for the run
 *  (the 54k-row full walk via `listFindingsForRun`), or can serve the
 *  default Queue + List purely from server pages.
 *
 *  The full load is only needed when a surface genuinely operates over
 *  the whole set client-side:
 *   - the audit / suppliers / GL-accounts tabs render the full population;
 *   - a client-only filter (rule / province / supplier / type / class /
 *     gl / currency / approval-reason / reason-codes / amount / eff-rate /
 *     carried-only / search, or an invoice sub-filter other than
 *     `attached`) filters the full set client-side — `deriveServerQueueQuery`
 *     returns null in exactly those cases, surfaced here as
 *     `hasClientOnlyFilter`;
 *   - a column sort on the List is applied (`listSortActive`) — sorting
 *     spans the whole set, so it needs every row;
 *   - the auto-cleared coverage rows are shown (`showAutoCleared`), which
 *     the server pages deliberately exclude.
 *
 *  When none hold, Queue + List run off `useServerFindingQueue`'s pages
 *  and the full walk never fires. */
export function needsFullFindings({
  tab,
  hasClientOnlyFilter,
  listSortActive,
  showAutoCleared,
}: {
  tab: string;
  hasClientOnlyFilter: boolean;
  listSortActive: boolean;
  showAutoCleared: boolean;
}): boolean {
  if (tab === 'audit' || tab === 'suppliers' || tab === 'glAccounts') return true;
  if (hasClientOnlyFilter) return true;
  if (listSortActive) return true;
  if (showAutoCleared) return true;
  return false;
}
